export const SAVE_ALL = 'SETTINGS_SAVE_ALL'
export const SET_DOWNLOAD_EVERYTHING = 'SETTINGS_SET_DOWNLOAD_EVERYTHING'
export const SET_RUN_CLIENTS_WITH_LOGGING = 'SETTINGS_SET_RUN_CLIENTS_WITH_LOGGING'
export const SET_RUN_CLIENTS_WITH_DX9 = 'SETTINGS_SET_RUN_WITH_DX9'
export const SET_SHOULD_MINIMIZE_TO_TRAY = 'SETTINGS_SET_SHOULD_MINIMIZE_TO_TRAY'
export const SET_LANGUAGE = 'SETTINGS_SET_LANGUAGE'
export const SET_TEST_SERVERS = 'SETTINGS_SET_TEST_SERVERS'



// WEBPACK FOOTER //
// ./src/features/Settings/data/backend/constants.js